var React = require('react');

function Marker (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#fff","fillRule":"evenodd","d":"M17.765 9.565c0 5.844-8.766 13.635-8.766 13.635S.234 15.409.234 9.565a8.765 8.765 0 0 1 17.53 0ZM9 12a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Z","clipRule":"evenodd"}));
}

Marker.defaultProps = {"fill":"none","viewBox":"0 0 18 24"};

module.exports = Marker;

Marker.default = Marker;
